import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="bg-background-100 paper-grain py-14 md:py-20">
      <div className="mx-auto max-w-8xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] text-primary-600">
              <i className="ri-question-line"></i>
              FAQ
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              常见问题
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于内容口径、线索投稿与更正流程，这里集中回答。如果还有疑问，欢迎直接通过投稿入口联系我们。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              还有问题？去留言
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {faqs.map((faq, index) => {
                const open = openId === faq.id;
                return (
                  <li
                    key={faq.id}
                    className="overflow-hidden rounded-lg border border-background-300/70 bg-background-50"
                  >
                    <h3>
                      <button
                        type="button"
                        aria-expanded={open}
                        onClick={() => setOpenId(open ? null : faq.id)}
                        className="flex w-full items-center gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100/70"
                      >
                        <span className="font-heading text-sm text-accent-700">
                          {String(index + 1).padStart(2, '0')}
                        </span>
                        <span className="flex-1 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                          {faq.q}
                        </span>
                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors ${
                            open
                              ? 'border-primary-300 bg-primary-500 text-background-50'
                              : 'border-background-300 text-foreground-500'
                          }`}
                        >
                          <i className={`text-lg ${open ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                        </span>
                      </button>
                    </h3>
                    {open && (
                      <div className="border-t border-background-200 px-5 pb-5 pt-4 pl-[3.25rem]">
                        <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
                          {faq.a}
                        </p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}